import type { Locale, Translations } from '@/intl/types'
import { BrandName } from '@/scopes/common/domain/types'

type TranslationImport = () => Promise<{ default: Translations }>

const translationsImportByLanguageMap: Record<BrandName, Partial<Record<Locale, TranslationImport>>> = {
  sunweb: {
    'fr-BE': () => import('./translations/sunweb/fr-BE.json'),
    'nl-BE': () => import('./translations/sunweb/nl-BE.json'),
    'nl-NL': () => import('./translations/sunweb/nl-NL.json'),
    'sv-SE': () => import('./translations/sunweb/sv-SE.json'),
    'da-DK': () => import('./translations/sunweb/da-DK.json'),
    'de-DE': () => import('./translations/sunweb/de-DE.json'),
    'en-GB': () => import('./translations/sunweb/en-GB.json'),
    'fr-FR': () => import('./translations/sunweb/fr-FR.json'),
  },
  eliza: {
    'nl-NL': () => import('./translations/eliza/nl-NL.json'),
    'nl-BE': () => import('./translations/eliza/nl-BE.json'),
  },
  gogo: {}, // GOGO CLEANUP
}

export function createTranslationRepository({ map = translationsImportByLanguageMap }) {
  async function getFor({ locale, brand }: { locale: Locale, brand: BrandName }) {
    const importTranslations = map[brand][locale]

    if (importTranslations == null) {
      console.warn(`Requested locale ${locale} is not available, falling back to nl-NL`)
      return (await import(`./translations/sunweb/nl-NL.json`)).default
    }

    const importedTranslations = await importTranslations()

    return importedTranslations.default
  }

  return { getFor }
}

export default createTranslationRepository({ map: translationsImportByLanguageMap })
